import type { JSX } from 'react';

import { LargeTitle, Text, Title } from '@telegram-apps/telegram-ui';

import type { ContentItem } from '@/api/entitties';

export const renderContent = (item: ContentItem): JSX.Element => {
  if (item) {
    if (typeof item !== 'object') {
      return <Text>{String(item)}</Text>;
    }

    if ('h1' in item && typeof item.h1 === 'string') {
      return <LargeTitle style={{margin: '16px 0 8px', ...(item.style && item.style)}}>{item.h1}</LargeTitle>;
    }

    if ('h2' in item && typeof item.h2 === 'string') {
      return <Title level={'1'} style={{margin: '16px 0 8px', ...(item.style && item.style)}}>{item.h2}</Title>;
    }

    if ('h3' in item && typeof item.h3 === 'string') {
      return <Title level={'2'} style={{margin: '16px 0 8px', ...(item.style && item.style)}}>{item.h3}</Title>;
    }

    if ('h4' in item && typeof item.h4 === 'string') {
      return <Title level={'3'} style={{margin: '16px 0 8px', ...(item.style && item.style)}}>{item.h4}</Title>;
    }

    if ('p' in item && typeof item.p === 'string') {
      return <Text style={{margin: '8px 0 16px', ...(item.style && item.style)}}>{item.p}</Text>;
    }

    if ('ul' in item && Array.isArray(item.ul)) {
      return (
        <ul style={{ margin: '8px 0 16px', paddingLeft: '24px', ...(item.style && item.style) }}>
          {item.ul.map((item, index) => {
            if (item && typeof item === 'object' && 'li' in item) {
              return (
                <li key={index} style={{ margin: '0 0 8px' }}>
                  {renderContent(item.li)}
                </li>
              );
            }
            return null;
          }).filter(Boolean)}
        </ul>
      );
    }
  }

  return <></>;
};